export const GET_PROPERTIES = "GET_PROPERTIES";
export const RESET_PROPERTIES = "RESET_PROPERTIES";
export const SET_PROPERTIES_REQUEST_STATUS = "SET_PROPERTIES_REQUEST_STATUS";
